import { Injectable, inject } from '@angular/core';

import { UserDBService } from '../db/user-db-service';
import { Resolve } from '@angular/router';
import { MKDEUserDto } from '@core/api';

@Injectable()
export class UserResolver implements Resolve<MKDEUserDto> {
  private userDbService = inject(UserDBService);

  public resolve() {
    return this.userDbService.getUser();
  }
}
